(function () {
  // Mobile layout (stacked columns) switches to scroll-driven autoplay
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const touchQuery = window.matchMedia('(hover: none)');

  function initShowcase(list) {
    if (list.dataset.showcaseInitialised === 'true') return;
    list.dataset.showcaseInitialised = 'true';

    const items = Array.from(list.querySelectorAll('[data-showcase-item]'));
    if (!items.length) return;

    let activeItem = null;
    let listVisible = false;
    let ticking = false;

    function playVideo(item) {
      const video = item.querySelector('[data-showcase-video]');
      if (!video) return;

      // preload="none" is set, so load() is required on first play
      if (video.readyState === 0) video.load();

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Once played, the video stays visible permanently
            item.classList.add('video-loaded');
          })
          .catch(() => {});
      } else {
        item.classList.add('video-loaded');
      }
    }

    function activate(item) {
      if (activeItem === item) return;

      items.forEach((el) => {
        if (el !== item) deactivate(el);
      });

      activeItem = item;
      item.classList.add('is-active');
      list.classList.add('has-active');
      playVideo(item);
    }

    function deactivate(item) {
      item.classList.remove('is-active');

      // Pause only, no currentTime reset and no hiding.
      // The image is an initial fallback; the video freezes in place.
      const video = item.querySelector('[data-showcase-video]');
      if (video && !video.paused) video.pause();
    }

    function clearAll() {
      activeItem = null;
      list.classList.remove('has-active');
      items.forEach(deactivate);
    }

    /* ---------- Mobile: the column at the middle of the screen plays ---------- */

    function updateFromScroll() {
      ticking = false;
      if (!mobileQuery.matches || !listVisible || !list.isConnected) return;

      const viewportCenter = window.innerHeight / 2;
      let closest = null;
      let closestDistance = Infinity;

      items.forEach((item) => {
        const rect = item.getBoundingClientRect();

        // The column that covers the screen center wins outright
        if (rect.top <= viewportCenter && rect.bottom >= viewportCenter) {
          closest = item;
          closestDistance = -1;
          return;
        }

        if (closestDistance < 0) return;

        const distance = Math.min(
          Math.abs(rect.top - viewportCenter),
          Math.abs(rect.bottom - viewportCenter)
        );
        if (distance < closestDistance) {
          closest = item;
          closestDistance = distance;
        }
      });

      if (closest) activate(closest);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateFromScroll);
    }

    // Only track scroll while the section is on screen
    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          listVisible = entry.isIntersecting;

          if (!mobileQuery.matches) return;

          if (listVisible) {
            requestUpdate();
          } else {
            clearAll();
          }
        });
      },
      { threshold: 0 }
    );
    visibilityObserver.observe(list);

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    // Switching between mobile and desktop layouts resets the state
    mobileQuery.addEventListener('change', () => {
      clearAll();
      if (mobileQuery.matches) requestUpdate();
    });

    /* ---------- Tablet / desktop ---------- */

    items.forEach((item) => {
      // Touch tablets: first tap = expand + play, second tap = open link
      item.addEventListener('click', (event) => {
        if (mobileQuery.matches || !touchQuery.matches) return;

        if (!item.classList.contains('is-active')) {
          event.preventDefault();
          activate(item);
        }
      });

      // Mouse: expand + play on hover
      item.addEventListener('mouseenter', () => {
        if (mobileQuery.matches || touchQuery.matches) return;
        activate(item);
      });

      item.addEventListener('mouseleave', () => {
        if (mobileQuery.matches || touchQuery.matches) return;
        clearAll();
      });

      // Keyboard accessibility
      const link = item.querySelector('.video-brand-showcase__link');
      if (link) {
        link.addEventListener('focus', () => {
          if (!mobileQuery.matches) activate(item);
        });
        link.addEventListener('blur', () => {
          if (!mobileQuery.matches) clearAll();
        });
      }
    });

    // Touch tablets: tapping outside collapses the active column
    document.addEventListener('click', (event) => {
      if (mobileQuery.matches || !touchQuery.matches) return;
      if (!list.contains(event.target)) clearAll();
    });

    if (mobileQuery.matches) requestUpdate();
  }

  function initAll() {
    document.querySelectorAll('[data-video-brand-showcase]').forEach(initShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', initAll);
})();